<template lang='slm'>
.bz-view
  div v-for='article in articleList' :key='article.id'
    bz-editor :id='article.id' v-if='article.editing'
    bz-article :id='article.id' v-else=''
</template>

<script>
import BzTreeItem from '@/components/mixins/bz-tree-item'
import FontAwesomeIcon from '@/fontawesome'
import BzArticle from '@/components/bz-tree/BzArticle'
import BzEditor from '@/components/BzEditor'

export default {
  name: 'BzView',
  props: ['articleIds'],
  mixins: [ BzTreeItem ],
  components: {
    BzEditor, FontAwesomeIcon, BzArticle
  },
  computed: {
    articleList () {
      return this.articleIds.map((id) => {
        return {id: id, editing: this.isEditing(id)}
      })
    }
  },
  methods: {
    isEditing (articleId) {
      let articleKey = this.compoundKey('articles', articleId)
      return this.$store.getters['editor/isEditing'](articleKey)
    }
  }
}
</script>

<style scoped lang='scss'>
.bz-view {
  text-align: justify;

  h1, h2, h3, h4, h5, h6 {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BzView.vue